import $script from 'scriptjs';
import { libHost } from './constants/urls';

export const injectScript = (url: string | string[], name: string) => {
  $script(url, name);

  return new Promise((resolve) => {
    $script.ready(name, () => {
      resolve(true);
    });
  });
};

const isDevelopment = process.env.NODE_ENV === 'development';

export const getLibEnvURL = (file) => {
  return isDevelopment ? `${libHost}/${file}` : `./${file}`;
};
